import { FC, useContext, useMemo, useState } from 'react';
import { Page, PageTitle } from '../../../components';
import { UnderContractList } from './under-contract-list';
import { useMediaQuery, FormControlLabel, Switch } from '@mui/material';
import { GlobalContext } from '../../../context/global';

interface IUnderContract {}

interface IUnderContractFilters {
  filters?: {
    neighborhoodIds?: string[];
    lotNumber?: string;
    search?: string;
    closingDateLocked?: boolean;
    showHiddenBuilds?: boolean;
  };
}

export const UnderContract: FC<IUnderContract> = () => {
  const removeStickyHeader = useMediaQuery('(max-width: 1850px)');

  const { filterValues } = useContext(GlobalContext);
  const currentFilterState = filterValues.find(state => state?.pageName === 'under-contract');
  const persistentFilters = useMemo<IUnderContractFilters>(
    () =>
      currentFilterState
        ? (currentFilterState as IUnderContractFilters)
        : ({} as IUnderContractFilters),
    [currentFilterState]
  );

  const [showHiddenBuilds, setShowHiddenBuilds] = useState<boolean>(
    persistentFilters?.filters?.showHiddenBuilds ?? false
  );

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setShowHiddenBuilds(!event.target.checked);
  };

  return (
    <Page
      pageHasStickyHeaders={removeStickyHeader ? false : true}
      title="Under Contract"
      showSideBar={false}
      sideBarLinks={[]}
    >
      <PageTitle
        title="Under Contract"
        additionalHeaderContent={
          <FormControlLabel
            control={
              <Switch
                color="primary"
                id="hide-client-builds"
                checked={!showHiddenBuilds}
                onChange={handleSwitchChange}
              />
            }
            label="Hide Excluded Builds"
          />
        }
      />
      <UnderContractList
        showHiddenBuilds={showHiddenBuilds}
        setShowHiddenBuilds={setShowHiddenBuilds}
      />
    </Page>
  );
};
